{
    "releaseNotes": {
        "tabName": "Historie vydání",
        "accordianHeading": "Vydání me@eon V<version>",
        "accordianMyHelpHeading": "Vydání MyHelp (me@eon) V<version>",
        "accordianMyHelpNewHeading": "Vydání MyHelp V<version>",
        "whatsNew": "Co je nového",
        "tipsAndTricks": "Tipy a triky",
        "faq": "Často kladené dotazy"
    },
    "ourTeam": {
        "tabName": "Náš tým",
        "keyMembers": "Klíčoví členové"
    },
    "featureRoadmap": {
        "tabName": "Funkce & Plán"
    }
}